var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlexLayout',{attrs:{"role":"region"}},[_c('BlockContainer',[_vm._v(" "+_vm._s(_vm.landingErrorMessage)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }